// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.fade-enter-active[data-v-e02b178e],\n.fade-leave-active[data-v-e02b178e] {\n  transition: opacity .3s ease;\n  position: relative;\n}\n.fade-enter-from[data-v-e02b178e],\n.fade-leave-to[data-v-e02b178e] {\n  opacity: 0;\n  position: absolute;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
